import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useYotpo } from '@srcDS/utils/useYotpo';

const waitForYotpoElements = (maxRetries = 20, delay = 300) => {
  return new Promise((resolve, reject) => {
    let attempts = 0;
    const check = () => {
      const widgets = document.querySelectorAll('[data-yotpo-element-id]');
      if (widgets.length > 0) {
        resolve(true);
      } else if (attempts >= maxRetries) {
        reject(new Error('Yotpo elements not found in time'));
      } else {
        attempts++;
        setTimeout(check, delay);
      }
    };
    check();
  });
};

const YotpoWidget = () => {
  const [loaderInjected, setLoaderInjected] = useState(false);
  const { getYotpoScriptUrl } = useYotpo();
  const yotpoScriptUrl = getYotpoScriptUrl();

  const shouldInitYotpo =
    typeof window !== 'undefined' && !window.location.pathname.includes('/q/');

  const loadYotpoLoader = useCallback(() => {
    if (typeof window === 'undefined' || loaderInjected || !yotpoScriptUrl) return;

    const existingScript = document.getElementById('YotpoLoaderScript');
    if (existingScript) return;

    const script = document.createElement('script');
    script.id = 'YotpoLoaderScript';
    script.async = true;
    script.defer = true;
    script.src = `${yotpoScriptUrl}?_=${Date.now()}`;

    script.onload = () => setLoaderInjected(true);

    document.head.appendChild(script);
  }, [yotpoScriptUrl, loaderInjected]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      loadYotpoLoader();
    }
  }, []);

  useEffect(() => {
    if (!shouldInitYotpo || typeof window === 'undefined') return;

    if (window.yotpo && window.yotpo.initWidgets) {
      waitForYotpoElements()
        .then(() => {
          window.yotpo.initWidgets(false);
          window.yotpo.refreshWidgets();
        })
        .catch(console.warn);
    }
  }, [shouldInitYotpo]);

  return typeof window !== 'undefined' && yotpoScriptUrl ? (
    <Helmet>
      <link rel="preload" as="script" href={yotpoScriptUrl} />
    </Helmet>
  ) : null;
};

export default YotpoWidget;
